import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { getEmailConnection } from "../../../services/emailChannel.api";

const MOTIVO = {
  AUTH_FAILED: "contraseña rechazada",
  UNREACHABLE: "servidor no responde",
};

/**
 * Filas de la tarjeta de una conexión de CORREO (doc 0445): el buzón y el modo, en lugar de «Número» y
 * «Token», que no significan nada para un correo. La lista de conexiones no trae el buzón; se pide aquí
 * para no tocar el listado común de todos los canales.
 */
const EmailCardDetails = ({ whatsAppId, status, classes }) => {
  const [datos, setDatos] = useState(null);

  useEffect(() => {
    let vivo = true;
    getEmailConnection(whatsAppId)
      .then(({ data }) => vivo && setDatos(data))
      .catch(() => vivo && setDatos(null));
    return () => {
      vivo = false;
    };
    // `status` cambia al conectar, desconectar o fallar: el modo se vuelve a leer.
  }, [whatsAppId, status]);

  const modo = !datos
    ? "…"
    : datos.lastErrorCode
      ? `Error: ${MOTIVO[datos.lastErrorCode] || datos.lastErrorCode}`
      : !datos.readEnabled
        ? "Solo envío"
        : datos.reading
          ? "Leyendo el buzón"
          : "Lectura detenida";

  return (
    <>
      <Box className={classes.connectionDetail}>
        <span className={classes.detailLabel}>Buzón:</span>
        <span className={classes.detailValue} title={datos?.address || ""}>{datos?.address || "…"}</span>
      </Box>
      <Box className={classes.connectionDetail}>
        <span className={classes.detailLabel}>Modo:</span>
        <span className={classes.detailValue} style={datos?.lastErrorCode ? { color: "#b71c1c" } : undefined}>{modo}</span>
      </Box>
    </>
  );
};

export default EmailCardDetails;
